import React, { Fragment } from 'react';
import {
    Input,
    InputLabel,
    InputAdornment,
    Card,
    CardContent,
    Button,
    FormControl,
    FormHelperText,
} from '@material-ui/core';
import { Redirect, useHistory } from 'react-router-dom';
import MailOutlineTwoToneIcon from '@material-ui/icons/MailOutlineTwoTone';
import validate from 'validate.js';
import { connect } from 'react-redux';
import {
    setData, onForgotPassword,
    clearData, verifyOtp, resetPassword
} from 'eebac/reducers/forgot_password';
import { VALIDATION_MESSAGES } from 'eebac/constants';
import { ROUTES_PATH_CONFIG } from 'eebac/config/routes';
import { withStyles } from '@material-ui/core/styles';
import EmailOtp from 'eebac/components/modals/email-otp';
import LockTwoToneIcon from '@material-ui/icons/LockTwoTone';
import IconButton from '@material-ui/core/IconButton';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

const validators = {
    Email: {
        presence: { allowEmpty: false, message: VALIDATION_MESSAGES.REQUIRED },
        email: {
            message: VALIDATION_MESSAGES.INVALID
        }
    },
    PasswordCaps: {
        presence: { allowEmpty: false, message: VALIDATION_MESSAGES.REQUIRED },
        format: {
            pattern: /[A-Z]+/,
            flags: "g",
            message: VALIDATION_MESSAGES.PASSWORD
        }
    },
    PasswordSmall: {
        format: {
            pattern: /[a-z]+/,
            flags: "g",
            message: VALIDATION_MESSAGES.PASSWORD
        }
    },
    PasswordNumbers: {
        format: {
            pattern: /[0-9]+/,
            flags: "g",
            message: VALIDATION_MESSAGES.PASSWORD
        }
    },
    PasswordChars: {
        format: {
            pattern: /[~!@#$%]+/,
            flags: "g",
            message: VALIDATION_MESSAGES.PASSWORD
        }
    }
}

const StyledCard = withStyles(theme => ({
    root: {
        margin: 'auto',
        maxWidth: '500px',

    }
}))(props => <Card className="card-box mb-4" {...props} />);

function ForgotPassword(props) {
    const history = useHistory();

    const {
        setData,
        userData,
        onForgotPassword,
        clearData,
        verifyOtp,
        resetPassword
    } = props;

    const setUserData = (key, value) => {
        setData([{ key: key, value: value }]);
    }

    const onResetPassword = () => {
        setData([{
            key: 'emailError',
            value: ''
        }, {
            key: 'errorMessage',
            value: ''
        }]);

        let errorMessage = validate.single(userData.email, validators.Email, { format: "flat" });
        if (errorMessage && errorMessage.length > 0) {
            setData([{
                key: 'emailError',
                value: errorMessage[0]
            }]);
        } else {
            onForgotPassword();
        }
    }

    const onPasswordChange = () => {
        setData([{
            key: 'passwordError',
            value: ''
        }, {
            key: 'errorMessage',
            value: ''
        }]);

        if (!validators.PasswordCaps.format.pattern.test(userData.password) ||
            !validators.PasswordSmall.format.pattern.test(userData.password) ||
            !validators.PasswordNumbers.format.pattern.test(userData.password) ||
            !validators.PasswordChars.format.pattern.test(userData.password) || userData.password.length < 8 ||
            userData.password.length > 16
        ) {
            setData([{
                key: 'passwordError',
                value: validators.PasswordCaps.format.message
            }]);
        } else {
            resetPassword();
        }
    }

    const redirectTo = path => {
        clearData();
        history.push(path);
    }

    const onOtpDailogClose = () => {
        setData([{
            key: 'openOtpDialog',
            value: false
        }, {
            key: 'otp',
            value: ''
        }, {
            key: 'isProcessing',
            value: false
        }, {
            key: 'otpError',
            value: ''
        }]);
    }

    const setOTP = (otp) => {
        if (/^[0-9]{1,6}$/.test(otp) || !otp) {
            setData([
                { key: "otp", value: otp },
                { key: "otpError", value: '' }
            ]);
        }
    }

    const onOTPResend = () => {
        onForgotPassword(true);
    }

    const onOTPVerify = () => {
        if (userData.isProcessing) {
            return false;
        }

        if (!(/^[0-9]{6}$/.test(userData.otp))) {
            setData([
                { key: "otpError", value: VALIDATION_MESSAGES.INVALID }
            ]);

            return false;
        }

        verifyOtp();
    }

    const [showPassword, setShowPassword] = React.useState(false);

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    return (
        <Fragment>
            {userData.isPasswordChanged &&
                <Redirect exact from="/" to={ROUTES_PATH_CONFIG.APP.signin} />
            }
            {userData.openOtpDialog && <EmailOtp open={true}
                onClose={onOtpDailogClose}
                email={userData.email}
                otpError={userData.otpError}
                isProcessing={userData.isProcessing}
                otp={userData.otp}
                setOTP={setOTP}
                onOTPResend={onOTPResend}
                onOTPVerify={onOTPVerify} />
            }
            <div style={{ padding: "70px 20px" }}>
                <StyledCard>
                    <div className="card-header">

                        <div className="card-header--title font-size-lg font-weight-bold text-center">
                            <div>
                                <a href="/">
                                    <img alt="eebac.com" src="/images/logo.png"
                                        style={{ width: "160px" }} />
                                </a>
                            </div>
                            Password assistance
                            {!userData.isOtpVerified && <div className="font-size-sm text-center font-weight-normal">
                                Enter the email address associated with your Eebac account.
                            </div>}
                            {userData.isOtpVerified && <div className="font-size-sm text-center font-weight-normal">
                                Enter the new password.
                            </div>}
                        </div>

                    </div>

                    <CardContent className="p-3">
                        <form className="px-5">
                            <div className="mb-1">
                                {!userData.isOtpVerified && <FormControl className="w-100">
                                    <InputLabel htmlFor="input-with-icon-adornment">
                                        Email address
                                    </InputLabel>
                                    <Input
                                        error={userData.emailError ? true : false}
                                        fullWidth
                                        id="input-with-icon-adornment"
                                        startAdornment={
                                            <InputAdornment position="start">
                                                <MailOutlineTwoToneIcon />
                                            </InputAdornment>
                                        }

                                        value={userData.email}
                                        onChange={(e) => { setUserData('email', e.target.value) }}
                                    />
                                </FormControl>
                                }
                                {userData.isOtpVerified && <FormControl className="w-100">
                                    <InputLabel htmlFor="standard-adornment-password">
                                        New Password
                                    </InputLabel>
                                    <Input
                                        error={userData.passwordError ? true : false}
                                        fullWidth
                                        type={showPassword ? 'text' : 'password'}
                                        id="standard-adornment-password"
                                        startAdornment={
                                            <InputAdornment position="start">
                                                <LockTwoToneIcon />
                                            </InputAdornment>
                                        }
                                        endAdornment={
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label="toggle password visibility"
                                                    onClick={handleClickShowPassword}
                                                    onMouseDown={handleMouseDownPassword}
                                                >
                                                    {showPassword ? <Visibility /> : <VisibilityOff />}
                                                </IconButton>
                                            </InputAdornment>
                                        }

                                        value={userData.password}
                                        onChange={(e) => { setUserData('password', e.target.value) }}
                                    />
                                    <FormHelperText style={{ color: "red" }}>
                                        {userData.passwordError}
                                    </FormHelperText>
                                </FormControl>
                                }
                            </div>
                            <div className="text-center mb-2">
                                <Button
                                    color="primary"
                                    variant="contained"
                                    size="large"
                                    className="my-2"
                                    onClick={userData.isOtpVerified ? onPasswordChange : onResetPassword}>
                                    {userData.isOtpVerified ? "Reset" : "Continue"}
                                </Button>
                            </div>

                            {!userData.isOtpVerified && <div>

                                <div className="font-size-md font-weight-bold">
                                    Has your email address changed?
                            </div>
                                <div className="font-size-sm font-weight-norm">
                                    If you no longer use the e-mail address associated with your Eebac account, you may contact <a className="text-primary" href="/#contactus">Customer Service</a> for help restoring access to your account.
                            </div>

                                <div className="text-center">
                                    <Button color="primary"
                                        className="m-2 text-primary px-0"
                                        onClick={() => redirectTo(ROUTES_PATH_CONFIG.APP.signin)}>

                                        <span>Sign In</span>
                                    </Button>
                                |
                                <Button color="primary"
                                        className="m-2 text-primary px-0"
                                        onClick={() => redirectTo(ROUTES_PATH_CONFIG.APP.register)}>
                                        <span>Create an Account</span>
                                    </Button>
                                </div>
                            </div>}
                        </form>
                    </CardContent>
                </StyledCard>
            </div>
        </Fragment>
    );
}


const mapStateToProps = state => ({
    userData: state.FORGOT_PASSWORD_DATA,
});

const mapDispatchToProps = dispatch => ({
    setData: data => dispatch(setData(data)),
    onForgotPassword: (isResend = false) => dispatch(onForgotPassword(isResend)),
    clearData: () => dispatch(clearData()),
    verifyOtp: () => dispatch(verifyOtp()),
    resetPassword: () => dispatch(resetPassword())
});

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);